export default "src/content/themes/association-wordpress-theme/img/107079646028378bd41b9b10fdbb5638.jpg";